import { cn } from '@/utils'

export const OperationNotesPlaceholder = ({ className }) => (
  <div
    style={{ width: 300, height: 100, borderColor: 'rgba(129, 140, 248, 0.5)' }}
    className={cn('border-4 rounded-md py-2 px-5 text-sm', className)}
  >
    <div style={{ padding: 5 }} className="text-gray-400">
      Write something or press &apos;/&apos; for commands...
    </div>
  </div>
)
